import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { formatCurrency } from "utils/helpers";

const useStyles = makeStyles((theme) => ({
  priceContainer: {
    height: "max-content",
    color: theme.palette.text.secondary,
  },
  lowestPrice: {
    color: theme.palette.text.primary,
    fontWeight: 700,
  },
  priceContainerDark: {
    color: theme.palette.text.onDark.secondary,
  },
}));

const LowestPrice = (props) => {
  const classes = useStyles();

  const startingRoomPrice = (availabilities, skipMemberRate) => {
    // Handle edge cases: no availabilities or empty array
    if (!availabilities || availabilities.length === 0) {
      return null;
    }

    // Filter out member rates if skipMemberRate is true, and any rate whose price
    // is obscured (null) - otherwise it wins the min and renders as £0.00
    const filteredAvailabilities = availabilities.filter((availability) => {
      const amount = availability.totalGrossAmount?.amount;
      if (amount === null || amount === undefined) return false;
      return !(skipMemberRate && availability.ratePlan.isMemberRate);
    });

    // Handle case where all availabilities are filtered out
    if (filteredAvailabilities.length === 0) {
      return null;
    }

    const lowestAvailability = filteredAvailabilities.reduce((min, availability) => {
      return min.totalGrossAmount.amount < availability.totalGrossAmount.amount
        ? min
        : availability;
    });

    const pricePerNight = lowestAvailability.totalGrossAmount.amount / (props.stayNights || 1);

    return formatCurrency(lowestAvailability.totalGrossAmount.currency, pricePerNight, false);
  };

  const formattedPrice = startingRoomPrice(props.availabilities, props.skipMemberRate);

  const hasLowestPrice = formattedPrice !== null;

  return hasLowestPrice ? (
    <Typography
      variant={props.fromVariant}
      className={clsx(classes.priceContainer, {
        [classes.priceContainerDark]: props.onDark,
      })}>
      from&nbsp;
      <Typography variant={props.priceVariant} className={classes.lowestPrice} component="span">
        {formattedPrice}
      </Typography>
      &nbsp;per night
    </Typography>
  ) : null;
};

LowestPrice.defaultProps = {
  fromVariant: "h6",
  priceVariant: "h5",
  onDark: true,
};

LowestPrice.propTypes = {
  availabilities: PropTypes.arrayOf(PropTypes.object),
  fromVariant: PropTypes.string,
  priceVariant: PropTypes.string,
  stayNights: PropTypes.number,
  onDark: PropTypes.bool,
  skipMemberRate: PropTypes.bool,
};

export default LowestPrice;
